import * as actionTypes from "../constants/cartConstants";

export const cartReducer = (state = { cart: {} }, action) => {
    switch(action.type){
        case actionTypes.ADD_TO_CART_REQUEST:
            state = {
                ...state,
                loading: true
            }
            break;
        case actionTypes.ADD_TO_CART_SUCCESS:
            state = {
                ...state,
                cartItems: action.payload.cartItems,
                priceDetails: action.payload.priceDetails || {},
                totalItems: action.payload.totalItems || 0,
                loading: false
              };
            break;
        case actionTypes.ADD_TO_CART_FAIL:
            state = {
                ...state,
                loading: false,
                error: action.payload.error
            }
            break;
        case actionTypes.RESET_CART_ITEMS:
            state = {
                cart: {}
            }
    }

return state;
}

// export const cartReducer = ( state = { cart: [] },action) => {

//     switch (action.type){
//         case actionTypes.ADD_TO_CART_REQUEST:
//             return {
//                 loading: true,
//                 cart: {}
//             };
//             case actionTypes.ADD_TO_CART_SUCCESS:
//                 return {
//                     loading: false,
//                     cartItems: action.payload.cartItems,
//                 };
//             case actionTypes.ADD_TO_CART_FAIL:
//                  return {
//                     loading: false,
//                      error: action.payload
//                 };
//             case actionTypes.RESET_CART_ITEMS:
//                  return {
//                     loading: false,
//                      error: action.payload
//                 };
//                  default:
//                  return state;
//     }
// };
